module.exports = __webpack_public_path__ + "img/portifolio_telecomunicacoes.38deae10.jpg";